const range = (start: any, end: any) => {
    return new Array(end - start).fill("").map((d, i) => i + Number(start));
  };
  
  export const years = range(2022, 2050);
  export const eventYears = range(1900, 2050);
  
  // export const dobYears = range(1900, new Date().getFullYear() - 17);
  export const allYears = range(1900, new Date().getFullYear() + 1);
  
  export const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  
  export const monthsShortened = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];